export default __webpack_public_path__ + "static/media/banking_circle.577e90b7.svg";